// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pDEz4","col":"styles_col__nClLj","actions":"styles_actions__3geoL","conflict":"styles_conflict__prIGK"};